<template>
  <item-box v-if="itemInfo" :deptObj="itemInfo" :getInfo="true"></item-box>
</template>

<script>
import itemBox from "../components/itemInfo";
export default {
  components: {
    itemBox,
  },
  data() {
    return {
      itemInfo: null,
    };
  },
  methods: {
    getMsgInfo() {
      this.$api.index
        .getNoticeInfo({
          id: this.$route.params.noticeId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.itemInfo = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
  },
  mounted() {
    this.getMsgInfo();
  },
};
</script>

<style scoped lang='less'>
.mar-right-10 {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}
.active-class {
  border-left: 2px solid #650004;
  background: #ffeff0;
}
.elipsis-class {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
ul li {
  list-style: initial;
  padding: 25px 0 0;
  cursor: pointer;
}
ul li::marker {
  color: red;
}
</style>
